import React from "react";
import { TkModalProps } from "../../../type/componentsType/TkModal";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import "./_style.scss";

/**
 * モーダル部品
 * TkModalコンポーネントは、MUIのModalコンポーネントを拡張したものです。
 * @param {TkModalProps} props - TkModalPropsコンポーネントのプロパティ
 * @param {boolean} props.open trueの場合、モーダルを開く。falseの場合、モーダルを閉じる
 * @returns TkModal モーダル部品
 */
export const TkModal: React.FC<TkModalProps> = (props) => {
  const { open = false, onChange, children, className, ...rest } = props;

  return (
    <Modal open={open} onChange={onChange} {...rest}>
      <Box className={`tkModal ${className}`}>{children}</Box>
    </Modal>
  );
};

export default TkModal;
